module.exports = __webpack_public_path__ + "img/nav_3_active.326d0634.gif";